import AdminLayout from "../../../components/admin/layout/AdminLayout";
import { useLocation } from "react-router-dom";
import useAuthStore from "../../../store/authStore";
import ManagerSidebar from "../../../components/managerLiveDashboard/sidebar/ManagerSidebar";
import BidApprove from "../../../components/common/bid/BidApprove";

function BidApprovePage() {
  const { userType } = useAuthStore();
  const location = useLocation();
  const ID = location.state || {};

  return (
    <AdminLayout
      sidebarComponent={userType === 'admin' ? undefined : ManagerSidebar}
    >
      <div className="p-0">
        <BidApprove edit={ID} />
      </div>
    </AdminLayout>
  );
}

export default BidApprovePage;
